import { Clear, Search } from '@mui/icons-material'
import { ReactElement } from 'react'
import { defaultTheme } from '../../../../../src/theme/index'
import { I18n } from 'common'
import { useSearchStore } from '../../../../../src/store/search/SearchStore'
import styled from 'styled-components'

const SaytRecommendationsBox = (): ReactElement => {
  const searchStore = useSearchStore()
  const clearRecommendations = () => {
    searchStore.saytRecommendations = []
  }
  return (
    <div className="sayt-recommendations-box">
      <div className="d-flex justify-content-between">
        <div className="text-uppercase font-oswald font-weight-700">
          <Search /> <I18n name="didYouMeanToSearchFor" />
        </div>
        <div>
          <StyledClear onClick={clearRecommendations} />
        </div>
      </div>
      <div>
        {searchStore?.saytRecommendations?.map((sayt, index) => {
          return (
            <>
              <SaytOption
                key={`sayt_rec_${sayt.text.trim}_${index}`}
                onClick={sayt.onClick}
              >
                {sayt.text}
              </SaytOption>
              {index < searchStore?.saytRecommendations?.length - 1 && '|'}
            </>
          )
        })}
      </div>
    </div>
  )
}

const SaytOption = styled.span`
  display: inline-block;
  margin: 1rem 1rem 0rem 1rem;
  border-bottom: 2px solid ${defaultTheme.colors.link};
  cursor: pointer;
  color: ${defaultTheme.colors.link};
`

const StyledClear = styled(Clear)`
  cursor: pointer;
`

export default SaytRecommendationsBox
